import Vue from 'vue';
import VueRouter from 'vue-router';

import Header from '../components/Header.vue';
import HomeBody from '../components/HomeBody.vue';
import Footer from '../components/Footer.vue';

const Body = () => import(/* webpackChunkName: "Landing-Inner" */ '../components/Body.vue');
const NotFound = () => import(/* webpackChunkName: "NotFound" */ '../components/NotFound.vue');
const Search = () => import(/* webpackChunkName: "Search" */ '../components/Search.vue');

Vue.use(VueRouter);

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      name: 'Home',
      path: '/',
      components: {
        header: Header,
        content: HomeBody,
        footer: Footer,
      },
    },
    {
      name: 'Search',
      path: '/search',
      components: {
        header: Header,
        content: Search,
        footer: Footer,
      },
    },
    {
      name: 'Landing',
      path: '/:landing',
      components: {
        header: Header,
        content: Body,
        footer: Footer,
      },
    },
    {
      name: 'Inner',
      path: '/:landing/:inner',
      components: {
        header: Header,
        content: Body,
        footer: Footer,
      },
    },
    {
      name: '404',
      path: '/404',
      components: {
        header: Header,
        content: NotFound,
        footer: Footer,
      },
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
